// extracted by mini-css-extract-plugin
module.exports = {"avatarImg":"form_avatarImg_2Bn78","clearButtonContainer":"form_clearButtonContainer_3cn1N"};